/* @flow */
const BADGES = {
  active: {
    og: require('assets/images/schools/SchoolView/badges/active---og.png'),
    png: require('assets/images/schools/SchoolView/badges/active@2x.png'),
    svg: require('assets/images/schools/SchoolView/badges/active.svg'),
  },
  emerging: {
    og: require('assets/images/schools/SchoolView/badges/emerging---og.png'),
    png: require('assets/images/schools/SchoolView/badges/emerging@2x.png'),
    svg: require('assets/images/schools/SchoolView/badges/emerging.svg'),
  },
  engaged: {
    og: require('assets/images/schools/SchoolView/badges/engaged---og.png'),
    png: require('assets/images/schools/SchoolView/badges/engaged@2x.png'),
    svg: require('assets/images/schools/SchoolView/badges/engaged.svg'),
  },
  growing: {
    og: require('assets/images/schools/SchoolView/badges/growing---og.png'),
    png: require('assets/images/schools/SchoolView/badges/growing@2x.png'),
    svg: require('assets/images/schools/SchoolView/badges/growing.svg'),
  },
};

const COLORS = {
  active: {
    dark: '#d34b37',
    light: '#f8905a',
  },
  emerging: {
    dark: '#464646',
    light: '#969696',
  },
  engaged: {
    dark: '#1c255f',
    light: '#3880d9',
  },
  growing: {
    dark: '#1b4642',
    light: '#4da487',
  },
};

const RATINGS = ['emerging', 'growing', 'active', 'engaged'];

export type EngagementRating = 'active' | 'emerging' | 'engaged' | 'growing';

export default {
  BADGES,
  COLORS,
  RATINGS,
};
